import { render } from "./SchemaHeading.vue?vue&type=template&id=3cf793a4"
import script from "./SchemaHeading.vue?vue&type=script&lang=js"
export * from "./SchemaHeading.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__